var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8210_62772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5067 21.7511L22.9712 25.2866L32.9649 35.2803L36.5004 31.7448L26.5067 21.7511Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 16.6667C32.3833 16.6667 35 14.0501 35 10.8334C35 9.86675 34.7333 8.96675 34.3167 8.16675L29.8167 12.6667L27.3333 10.1834L31.8333 5.68341C31.0333 5.26675 30.1333 5.00008 29.1667 5.00008C25.95 5.00008 23.3333 7.61675 23.3333 10.8334C23.3333 11.5167 23.4667 12.1667 23.6833 12.7667L20.6 15.8501L17.6333 12.8834L18.8167 11.7001L16.4667 9.35008L20 5.81675C18.05 3.86675 14.8833 3.86675 12.9333 5.81675L7.03333 11.7167L9.38333 14.0667H4.68333L3.5 15.2501L9.4 21.1501L10.5833 19.9667V15.2501L12.9333 17.6001L14.1167 16.4167L17.0833 19.3834L4.73333 31.7334L8.26667 35.2667L27.2333 16.3167C27.8333 16.5334 28.4833 16.6667 29.1667 16.6667Z",
    fill: "#E8E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8210_62772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.bfe52662a084d6451ba09b32c24e0f42.svg";
export { ForwardRef as ReactComponent };